class EventBuilder {
  static createDragleaveEvent () {
    return new CustomEvent('dragleave')
  }

  static createDragoverEvent () {
    return new CustomEvent('dragover')
  }

  static createDropEvent (detail) {
    return new CustomEvent('drop', { detail })
  }

  static createPressEndEvent () {
    return new CustomEvent('pressEnd')
  }

  static createPressHoldStartEvent () {
    return new CustomEvent("pressHoldStart")
  }

  static createPressHoldEndEvent () {
    return new CustomEvent('pressHoldEnd')
  }
}

export default EventBuilder
